import * as actions from "../constants/ActionTypes";

export const setEditableTextRow = (dataComponentId, isEditing) => ({
  type: actions.SET_EDITABLE_ROW,
  payload: {
    dataComponentId,
    isEditing,
  },
});
